package music.limasoul.client.shared.navigation

import androidx.navigation.NavHostController

interface Router {

    fun navigateTo(destination: Navigation)

    fun back()

    fun navigateToHome()
}

internal class AppRouter(
    private val navController: NavHostController,
) : Router {

    override fun navigateTo(destination: Navigation) {
        navController.navigate(destination)
    }

    override fun back() {
        navController.popBackStack()
    }

    override fun navigateToHome() {
        navController.navigate(
            Navigation.Event.List,
        ) {
            popUpTo<Navigation.Event.List> {
                inclusive = true
            }
        }
    }
}